<template>
  <div class="Stub-Blur">
    <div class="Stub-Blur__box"></div>
    <div class="Stub-Blur__content">
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
  @import "./styles/_styles.scss";
</style>